export default __webpack_public_path__ + "static/media/CallIcon.5bd14579.svg";